<template>
  <div :class="`container1break`">
    <q-chat-message
      text-html
      :text="[
        inputText
      ]"
      text-color="black"
      bg-color="transparent"
    />
  </div>
</template>

<script lang="ts">
  import { Component, Emit, Prop, Vue } from 'vue-facing-decorator';
  
  @Component({
    name: 'ReportBreakPreview',
    components: {}
  })
  export default class ReportBreakPreview extends Vue {
    @Prop({ default: undefined })
    inputText?: string
    @Prop({ default: 1 })
    elementScale?: number
  }
</script>

<style lang="scss">

.container4break {
  float: left;
  width: calc(25% - 20px);
  min-width: calc(25% - 20px);
  max-width: calc(25% - 20px);
  height: 40vh;
  margin: 10px;
  border-radius: 0;
  position: relative;
  overflow: hidden;
  display: block;
  border: 1px solid transparent;
  cursor: pointer;

  & > * {
    pointer-events: none;
  }
}

.container4break:hover {
  border: 1px solid lightgrey;
}

.container2break {
  float: left;
  width: calc(50% - 20px);
  min-width: calc(50% - 20px);
  max-width: calc(50% - 20px);
  height: 40vh;
  margin: 10px;
  border-radius: 0;
  position: relative;
  overflow: hidden;
  display: block;
  border: 1px solid transparent;
  cursor: pointer;

  & > * {
    pointer-events: none;
  }
}

.container2break:hover {
  border: 1px solid lightgrey;
}

.container1break {
  float: left;
  width: calc(100% - 20px);
  min-width: calc(100% - 20px);
  max-width: calc(100% - 20px);
  margin: 10px;
  border-radius: 0;
  position: relative;
  overflow: hidden;
  display: block;
  border: 1px solid transparent;
  cursor: pointer;

  & > * {
    pointer-events: none;
  }
}

.container1break:hover {
  border: 1px solid lightgrey;
}

</style>